import {createFeatureFlagsStore} from '#imports';

export const useFeatureFlagsStoreUnlogged = createFeatureFlagsStore(
    ['navbar-search-panel-v2', 'resolve-locale-from-ip-or-account'],
    'navbar-module-feature-flags',
);
